import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { parseLocalDate, toIsoLocal, formatFrDate } from "@/lib/dates";

/** Date ultra-compacte : icône calendrier + badge dd/mm/aa, sélection en popover (+ saisie clavier).
 *  LOT 47 : dates traitées en LOCAL (jamais UTC) pour éviter le décalage d'un jour en Guadeloupe (UTC-4). */
export default function DateBadge({ value, onChange, disabled, testId, placeholder = "Date" }) {
    const [open, setOpen] = useState(false);
    const label = formatFrDate(value);
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button type="button" data-testid={testId} disabled={disabled} title={label || placeholder} aria-label={placeholder}
                    className={cn("inline-flex w-24 min-w-[6rem] max-w-[6rem] shrink-0 items-center justify-center gap-1 rounded-full border px-1.5 h-8 text-xs whitespace-nowrap overflow-hidden transition-colors", label ? "border-primary/40 bg-accent/60 text-foreground" : "border-dashed border-border text-muted-foreground hover:text-foreground")}>
                    <CalendarDays className="h-3.5 w-3.5" />{label || <span className="sr-only">{placeholder}</span>}
                </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="w-auto p-2 space-y-2">
                <div className="flex items-center gap-2">
                    <Input type="date" data-testid={testId ? `${testId}-input` : undefined} value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-8 text-xs" />
                    {value && <button type="button" data-testid={testId ? `${testId}-clear` : undefined} onClick={() => { onChange(""); setOpen(false); }} className="text-muted-foreground hover:text-destructive"><X className="h-4 w-4" /></button>}
                </div>
                <Calendar mode="single" selected={parseLocalDate(value) || undefined} onSelect={(d) => { if (d) { onChange(toIsoLocal(d)); setOpen(false); } }} initialFocus />
            </PopoverContent>
        </Popover>
    );
}
